<template>
    <a-sub-menu :key="menuInfo.key" v-bind="$props">
        <template #title>
            <span>
                <span :class="styles.title">{{ menuInfo.title }}</span>
                <span v-if="menuInfo.count" class="badge badge-success ml-2">{{ menuInfo.count?.value }}</span>
                <i v-if="menuInfo.icon" :class="[styles.icon, menuInfo.icon]" />
            </span>

            <!--  
            <router-link v-if="menuInfo.url && menuInfo.newTab == false" :to="menuInfo.url">
                <span :class="styles.title">{{ menuInfo.title }}</span>
                <span v-if="menuInfo.count?.value" class="badge badge-danger ml-2">{{ menuInfo.count?.value }}</span>
                <i v-if="menuInfo.icon" :class="[styles.icon, menuInfo.icon]" />
            </router-link>

            <item :key="menuInfo.key" :menu-info="menuInfo" :styles="styles" />
            -->
        </template>
        <template v-for="item in menuInfo.children">

            <item v-if="!item.children && !item.divider" :key="item.key" :menu-info="item" :styles="styles" />

            <!-- menu sem drop, que tem children, mas não são para aparecer -->
            <item v-if="item.showDrop == false" :key="item.key" :menu-info="item" :styles="styles" />

            <sub-menu v-if="item.children && item.showDrop != false" :key="item.key" :menu-info="item" :styles="styles" />
        </template>
    </a-sub-menu>
</template>

<script>
import { Menu } from 'ant-design-vue'
import Item from './item'

export default {
    name: 'SubMenu',
    components: { Item },
    isSubMenu: true,
    props: {
        ...Menu.SubMenu.props,
        menuInfo: {
            type: Object,
            default: () => {},
        },
        styles: {
            type: Object,
            default: () => {},
        },
    },
}
</script>
